import { create } from "zustand";
import { PatientStoreSlice, createPatientStore } from "./patients.store";

interface PatientStoreType extends PatientStoreSlice {}

export const usePatientStore = create<PatientStoreType>((...args) => ({
	...createPatientStore(...args),
}));
